import { TopNavButtonUnstyled } from 'Components/Header/TopNavButton/unstyled'
import styled from 'styled-components'

export const TopNavButton = styled(TopNavButtonUnstyled)`
  display: inline-block;
  position: relative;
  color: ${props => props.theme.colors.white};
  min-width: 70px;
  max-height: 100%;
  height: 70px;
  cursor: pointer;
  padding: ${props => (props.children ? '0 30px 0 60px' : '0')};

  @media (max-width: 500px) {
    padding: ${props => (props.children ? '0 15px 0 15px' : '0')};

    svg {
      display: none;
    }
  }

  .opacity-background {
    display: block;
    position: absolute;
    background: ${props => props.theme.colors.secondary};
    width: 100%;
    height: 100%;
    opacity: 0;
    z-index: ${props =>
      props.theme.zIndexes.header.topNavButton.opacityBackground};
  }

  & > div:last-child {
    display: block;
    width: 100%;
    font-size: ${props => props.theme.fontSizes.header.desktopButton};
    line-height: 70px;
    text-decoration: none;
    color: ${props => props.theme.colors.white};
  }

  svg {
    width: 14px;
    position: absolute;
    height: 100%;
    fill: ${props => props.theme.colors.white};
    left: ${props => (props.children ? '30px' : '0')};
    right: ${props => (props.children ? 'auto' : '0')};
    margin: auto;
  }

  &:hover .opacity-background,
  &.active .opacity-background {
    opacity: 1;
  }

  &:hover svg,
  &.active svg {
    fill: ${props => props.theme.colors.primary};
  }
`



// WEBPACK FOOTER //
// ./src/Components/Header/TopNavButton/index.js